<template>
  <div class="animated fadeIn">
    <div class="row mt-3">
      <div class="col-12">
        <div style="font-size: 14px">
          <i class="fas fa-home text-third"></i> <strong>{{ sectionName }}</strong>
          <span v-for="(item, index) in pathFolder" v-bind:key="index">
            / <i class="fas fa-folder-open text-third"></i> {{ item }}
          </span>
          <span style="padding-left: 10px;" v-b-tooltip.hover title="Compartilhamento" @click="onShared">
            <i class="fas fa-user-friends text-third"></i>
          </span>
        </div>
        <div style="font-size: 12px; display: block; position: absolute; right: 18px;top: -4px;">
          <span v-b-tooltip.hover title="Fechar Pasta">
            <a href="javascript:void(0);" @click="$emit('Close')">Fechar</a> <i class="fas fa-window-close text-danger"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <Tables ref="tableGrid"
                :columns="['Arquivo', 'Dt. Anexo', 'Versão', 'Tamanho', 'Tipo', 'Atividade', $lang.Common.DataTable.Actions]"
                :showNew="true"
                :showSearch="true"
                :showReload="true"
                v-on:Reload="onReload"
                v-on:New="onNew"
                v-on:Search="onShowSearch"
        >
          <template v-slot:table-header-buttons>
            <a href="javascript:void(0);" class="d-md-down-none" v-b-tooltip.hover :title="'Configurações'" @click="onSettings">
              <i class="fa fa-cog text-third" style="font-size: 15px"></i>
            </a>
          </template>
          <tr v-for="(obj, index) in this.objList" v-bind:key="index">
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.anexoData ? obj.anexoData : ''" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.versao ? 'v' + obj.versao.toString() : ''" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.anexoTamanho ? bytesToSize(obj.anexoTamanho) : ''" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.anexoTipo ? onGetType(obj.anexoTipo) : ''" />
            <TableColumn :IsCustom="true">
                <span :id="`popover-target-${index}`" v-if="obj.tarefas"><strong><i class="fas fa-comment text-third"></i></strong></span>
                <b-popover :target="`popover-target-${index}`" triggers="hover" placement="lefttop" v-if="obj.tarefas">
                  <template #title class="bg-third">Atividades</template>
                  <div style="font-size: 10px">
                    <div v-for="(task, indexTask) in obj.tarefas" :key="indexTask">
                      <div v-if="indexTask > 0" class="mt-2 mb-2 w-100"><hr /></div>
                      <div class="d-flex justify-content-between">
                        <table :style="(task.realizado) ? 'opacity: 0.6' : ''">
                          <tr>
                            <td>Tipo:</td>
                            <td><strong>{{ task.tipoTarefa.nome }}</strong></td>
                          </tr>
                          <tr>
                            <td>Criado em:</td>
                            <td>{{ moment(task.criacaoData).format('DD/MM/YYYY') }}</td>
                          </tr>
                          <tr>
                            <td>Por:</td>
                            <td>{{ task.criador.pessoa.nome }}</td>
                          </tr>
                          <tr>
                            <td>Responsável:</td>
                            <td>{{ task.responsavel.pessoa.nome }}</td>
                          </tr>
                          <tr>
                            <td>Dt.Limite:</td>
                            <td><strong>{{ moment(task.lembrarData).format('DD/MM/YYYY') }}</strong></td>
                          </tr>
                          <tr>
                            <td>Observação:</td>
                          </tr>
                          <tr>
                            <td colspan="2">{{ task.observacao }}</td>
                          </tr>
                          <tr v-if="task.realizado">
                            <td colspan="2" class="text-success"><strong>CONCLUÍDO</strong></td>
                          </tr>
                          <tr v-if="task.realizado">
                            <td colspan="2">Em <strong>{{ moment(task.conclusaoData).format('DD/MM/YYYY HH:mm') }}</strong></td>
                          </tr>
                          <tr v-else>
                            <td colspan="2" class="text-right">
                              <b-button class="btn btn-third" style="font-size: 11px; padding: 3px 5px;" @click="onCloseTask(task)">
                                <i class="fas fa-check"></i> Concluir
                              </b-button>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </b-popover>
            </TableColumn>
            <TableColumn :IsCustom="true">
              <span v-b-tooltip.hover title="Adicionar uma atividade" @click="onAddTask(obj)">
                <i class="fas fa-tasks icone-grid text-third"></i>
              </span>
              <span class="ml-2" v-b-tooltip.hover title="Visualizar" @click="onView(obj)">
                <i class="fas fa-eye icone-grid text-third"></i>
              </span>
              <span class="ml-2" v-b-tooltip.hover title="Download" @click="onDownload(obj)">
                <i class="fas fa-download icone-grid text-third"></i>
              </span>
              <span class="ml-2" v-b-tooltip.hover title="Excluir">
                <b-dropdown variant="link" size="sm" no-caret>
                  <template slot="button-content">
                    <i class="fas fa-trash-alt text-third icone-grid"></i><span class="sr-only">{{ $lang.Common.Buttons.Delete }}</span>
                  </template>
                  <b-dropdown-header><strong>{{ $lang.Common.ConfirmDelete }}</strong></b-dropdown-header>
                  <b-dropdown-item href="javascript:void(0);" @click="onDelete(obj)">{{ $lang.Common.Yes }}</b-dropdown-item>
                  <b-dropdown-item href="javascript:void(0);">{{ $lang.Common.No }}</b-dropdown-item>
                </b-dropdown>
              </span>
            </TableColumn>
          </tr>
        </Tables>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="text-center"
             style="background-color: #fff; border: dotted 1px #04a791; padding: 20px; border-radius: 5px;"
             draggable="true"
             @drop.prevent="onDrop"
             @dragover.prevent
             @click="addFiles()">
          <div class="pt-5"><i class="fas fa-upload text-third"></i></div>
          <div><strong>Clique para enviar um arquivo</strong> ou arraste e solte aqui</div>
          <div class="pb-5"><small>Tamanho máximo permitido: 30mb</small></div>
        </div>
      </div>
    </div>
    <div class="row tex-center">
      <div class="col-12 text-center mt-5 pt-5">
        <img src="/static/img/bg/bg_folder_files.svg" style="width: 15%; opacity: 0.2; position: fixed; bottom: 35px; right: 10px;"/>
      </div>
    </div>
    <ModalGedUpload ref="ModalGedUpload" v-on:Import="OnImport" />
    <ModalGedSharing ref="ModalGedSharing" />
    <ModalGedFolderSettings ref="ModalGedFolderSettings" v-on:ReloadMenu="onReloadMenu" />
    <ModalGedTask ref="ModalGedTask" v-on:Saved="onReload" />
    <ModalGedPreview ref="ModalGedPreview" />
    <input
      type="file"
      ref="fileGed"
      style="display: none;"
      multiple
      @change="handleFilesUpload()"
    />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import GedRepository from '@/shared/http/repositories/ged/ged.js'
import GedTarefaRepository from '@/shared/http/repositories/ged/gedtarefa.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import { JWTService } from '@/shared/services/jwt'

import RightContentSearch from './search/rightcontent-search.vue'
import ModalGedUpload from './components/modalupload.vue'
import ModalGedSharing from './components/modalsharing.vue'
import ModalGedFolderSettings from './components/modalsettings.vue'
import ModalGedTask from './components/modaltask.vue'
import ModalGedPreview from './components/modalpreview.vue'

export default {
  name: 'RightContentGed',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      item: null,
      data: null,
      form: null,
      files: [],
      uploadingFiles: []
    }
  },
  components: {
    ModalGedUpload,
    ModalGedSharing,
    ModalGedFolderSettings,
    ModalGedTask,
    ModalGedPreview
  },
  computed: {
    pathFolder () {
      let result
      if (this.item && this.item.path) {
        result = this.item.path
      }
      return result
    },
    sectionName () {
      let result
      if (this.item && this.item.secao) {
        result = this.item.secao.nome
      }
      return result
    },
    importFiles () {
      var result = []
      if (this.files && this.files.length > 0) {
        result = this.files
      }
      return result
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    this.$eventHub.on('Filter', ({ filters }) => {
      this.filters = filters
      this.$refs.tableGrid.currentPage = 0
      this.$refs.tableGrid.pagingIndex = 0
      this.$nextTick(() => {
        this.onLoad()
      })
    })
  },
  methods: {
    onLoad () {
      this.onOpen(this.item)
    },
    onReload () {
      this.onLoad()
    },
    onLoadAll () {
      this.onLoad()
    },
    onReloadMenu (menu) {
      if (this.item && this.item.path) {
        this.item.path[this.item.path.length - 1] = menu.nome
      }
      this.$emit('ReloadMenu')
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: RightContentSearch
      }
      this.$eventHub.emit('Search', aside)
    },
    onOpen (obj) {
      if (obj) {
        this.item = obj
        let search = `${obj.id}`
        if (this.filters) {
          search += `&nome=${this.filters.nome}`
        }
        GedRepository.GetAllByMenu(search, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },
    onNew () {
      this.$refs.fileGed.files = null
      this.addFiles()
    },
    onDownload (obj) {
      loading.push()
      GedRepository.Download(obj.id)
        .then((response) => {
          loading.pop()
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', obj.nome)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      GedRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onCloseTask (task) {
      if (task) {
        console.log(task)
        GedTarefaRepository.Close(task.id)
          .then((response) => {
            loading.pop()
            toast.success('Atividade concluída com sucesso!', 'CONCLUSÃO DE ATIVIDADES')
            this.onLoad()
          })
          .catch(this.onException)
      }
    },
    onView (obj) {
      this.$refs.ModalGedPreview.showModal(obj)
    },
    onShared () {
      this.$refs.ModalGedSharing.showModal(this.item)
    },
    onSettings () {
      let gedLength = this.objList ? this.objList.length : 0
      this.$refs.ModalGedFolderSettings.showModal(this.item, gedLength)
    },
    onAddTask (obj) {
      this.$refs.ModalGedTask.showModal(obj)
    },
    addFiles () {
      this.$refs.fileGed.click()
    },
    handleFilesUpload () {
      this.files = []
      const files = this.$refs.fileGed.files
      for (const index in files) {
        if (files[index].size > 0) {
          this.files.push(files[index])
        }
      }
      this.$refs.fileGed.files = null
      this.$refs.ModalGedUpload.showModal(this.files)
    },
    onDragOver (event) {
      event.preventDefault()
      // Set the dropEffect to move
      event.dataTransfer.dropEffect = 'move'
    },
    onDrop (event) {
      this.files = []
      const files = event.dataTransfer.files
      for (const index in files) {
        if (files[index].size > 0) {
          this.files.push(files[index])
        }
      }
      this.$refs.ModalGedUpload.showModal(this.files)
    },
    bytesToSize (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return '0 Byte'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    async OnImport (filesUpload) {
      this.files = []
      this.$refs.fileGed.files = null

      if (filesUpload.length > 0) {
        for await (let objFile of filesUpload) {
          loading.push()
          let ged = {
            menuId: this.item.id,
            secaoId: this.item.secao.id,
            userId: JWTService.GetUserId()
          }
          const jsonGed = new Blob([JSON.stringify(ged)], {
            type: 'application/json'
          })
          let formData = new FormData()
          formData.append('file', objFile)
          formData.append('data', jsonGed)
          try {
            await GedRepository.Create(formData)
              .then(this.onResult)
              .catch(this.onException)
          } catch (error) {
            this.onException(error)
            loading.close()
          }
        }
      } else {
        toast.warning('Nenhum arquivo selecionado', 'Upload de Arquivos')
      }
    },
    onGetType (fileType) {
      let result = fileType
      switch (fileType) {
        case 'application/pdf':
          result = 'PDF'
          break
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          result = 'DOCX'
          break
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          result = 'XLSX'
          break
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          result = 'PPTX'
          break
        case 'application/vnd.ms-excel':
          result = 'XLS'
          break
        case 'application/msword':
          result = 'DOC'
          break
        case 'application/vnd.ms-powerpoint':
          result = 'PPT'
          break
        case 'application/zip':
          result = 'ZIP'
          break
        case 'application/x-zip-compressed':
          result = 'ZIP'
          break
        case 'application/x-rar-compressed':
          result = 'RAR'
          break
        case 'application/x-7z-compressed':
          result = '7Z'
          break
        case 'application/x-tar':
          result = 'TAR'
          break
        case 'application/x-gzip':
          result = 'GZIP'
          break
        case 'application/x-bzip2':
          result = 'BZIP2'
          break
        case 'application/text':
          result = 'TXT'
          break
        case 'application/json':
          result = 'JSON'
          break
        case 'application/xml':
          result = 'XML'
          break
        case 'application/vnd.ms-outlook':
          result = 'PST'
          break
        case 'application/vnd.ms-access':
          result = 'MDB'
          break
        case 'application/vnd.ms-project':
          result = 'MPP'
          break
        case 'application/vnd.ms-visio.drawing':
          result = 'VSD'
          break
        case 'application/vnd.ms-visio.stencil':
          result = 'VSS'
          break
        case 'application/vnd.ms-visio.template':
          result = 'VST'
          break
        case 'application/vnd.ms-visio.xml':
          result = 'VSDX'
          break
        case 'application/vnd.ms-visio.stencil.xml':
          result = 'VSSX'
          break
        case 'application/vnd.ms-visio.template.xml':
          result = 'VSTX'
          break
        case 'application/vnd.ms-visio.macroEnabled.xml':
          result = 'VSDM'
          break
        case 'application/vnd.ms-visio.stencil.macroEnabled.xml':
          result = 'VSSM'
          break
        case 'application/png':
          result = 'PNG'
          break
        case 'application/jpeg':
          result = 'JPEG'
          break
        case 'application/gif':
          result = 'GIF'
          break
        case 'application/tiff':
          result = 'TIFF'
          break
        case 'application/bmp':
          result = 'BMP'
          break
        case 'application/svg+xml':
          result = 'SVG'
          break
        case 'application/vnd.openxmlformats-officedocument.presentationml.slide':
          result = 'SLDX'
          break
        case 'application/vnd.openxmlformats-officedocument.presentationml.slideShow':
          result = 'PPSX'
          break
        case 'application/vnd.openxmlformats-officedocument.presentationml.template':
          result = 'POTX'
          break
        case 'application/vnd.openxmlformats-officedocument.presentationml.slide.macroEnabled':
          result = 'SLDXM'
          break
        case 'application/vnd.openxmlformats-officedocument.presentationml.slideShow.macroEnabled':
          result = 'PPSXM'
          break
        case 'application/mp4':
          result = 'MP4'
          break
        case 'application/avi':
          result = 'AVI'
          break
        case 'application/mov':
          result = 'MOV'
          break
        case 'application/wmv':
          result = 'WMV'
          break
        case 'application/flv':
          result = 'FLV'
          break
        case 'application/mpeg':
          result = 'MPEG'
          break
        case 'application/3gp':
          result = '3GP'
          break
        case 'application/ogg':
          result = 'OGG'
          break
        case 'application/webm':
          result = 'WEBM'
          break
        case 'application/x-matroska':
          result = 'MKV'
          break
        case 'application/x-msdownload':
          result = 'EXE'
          break
        case 'application/x-shockwave-flash':
          result = 'SWF'
          break
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/ged/rightcontent/rightcontent.vue